// import { Navigate, useLocation, useSearchParams } from 'react-router-dom';
// import { useRootSelector } from '@/hooks/selector.hook';
// import { useEffect, useRef } from 'react';
// import { getKycStatus } from '@/utils/common';

interface KYCMiddlewareProps {
  children: React.ReactElement;
}

// type kycStatusType = 'NotKyc' | 'UnderReview' | 'Approved' | 'Rejected';

// const getKYCRedirectUrl = (kycStatus?: kycStatusType | null): string | null => {
//   switch (kycStatus) {
//     case 'Approved':
//       return null; // Có thể vào bất kỳ trang nào (trừ các trang bị block)
//     case 'NotKyc':
//       return '/kyc/submit';
//     case 'UnderReview':
//       return '/kyc/pending';
//     case 'Rejected':
//       return '/kyc/resubmit';
//     default:
//       return null;
//   }
// };

// Các trang KYC bị block khi kycStatus là Approved (redirectUrl null)
// const BLOCKED_KYC_PAGES = ['/kyc/submit', '/kyc/pending', '/kyc/resubmit'];

export default function KYCMiddleware({ children }: KYCMiddlewareProps) {
  // const location = useLocation();
  // const [searchParams] = useSearchParams();
  // const kycStatusFromRedux = useRootSelector((state) => state.auth.kycStatus);
  // const prevLocationRef = useRef<string>(location.pathname);
  // const isInitialMount = useRef<boolean>(true);

  // // Check nếu user click từ email (có query param fromEmail hoặc verified)
  // const isFromEmail = searchParams.get('fromEmail') === 'true' || searchParams.get('verified') === 'true';

  // // Lấy kycStatus từ localStorage (ưu tiên) hoặc Redux - LUÔN lấy mới nhất
  // const currentKycStatus = (getKycStatus() as kycStatusType) || kycStatusFromRedux;

  // // Lấy URL yêu cầu theo kycStatus
  // const currentRequiredUrl = getKYCRedirectUrl(currentKycStatus);

  // // Check và redirect ngay khi location thay đổi
  // useEffect(() => {
  //   // Bỏ qua lần đầu mount (khi đang login)
  //   if (isInitialMount.current) {
  //     isInitialMount.current = false;
  //     prevLocationRef.current = location.pathname;
  //     return;
  //   }

  //   // Chỉ check khi location thực sự thay đổi (user navigate)
  //   if (prevLocationRef.current === location.pathname) {
  //     return;
  //   }

  //   prevLocationRef.current = location.pathname;

  //   // Lấy lại kycStatus từ localStorage (có thể đã được update)
  //   const latestKycStatus = (getKycStatus() as kycStatusType) || kycStatusFromRedux;
  //   if (!latestKycStatus) {
  //     return;
  //   }

  //   const latestRequiredUrl = getKYCRedirectUrl(latestKycStatus);

  //   // Nếu kycStatus là Approved, không cần check
  //   if (latestRequiredUrl === null) {
  //     return;
  //   }

  //   // Nếu user đang ở trang KYC khác với trang yêu cầu, redirect ngay
  //   if (location.pathname.startsWith('/kyc') && location.pathname !== latestRequiredUrl) {
  //     window.location.href = latestRequiredUrl;
  //     return;
  //   }

  //   // Nếu user đang ở trang không phải KYC nhưng kycStatus yêu cầu một trang KYC
  //   if (!location.pathname.startsWith('/kyc') && latestRequiredUrl) {
  //     window.location.href = latestRequiredUrl;
  //     return;
  //   }
  // }, [location.pathname, kycStatusFromRedux]);

  // // Nếu không có kycStatus, cho phép vào
  // if (!currentKycStatus) {
  //   return children;
  // }

  // // Logic khi kycStatus là Approved (requiredUrl === null, tương đương redirectUrl null)
  // if (currentRequiredUrl === null) {
  //   // Nếu user đang ở các trang KYC bị block, redirect về dashboard hoặc verified
  //   if (BLOCKED_KYC_PAGES.includes(location.pathname)) {
  //     if (isFromEmail) {
  //       return <Navigate to="/kyc/verified" replace />;
  //     }
  //     return <Navigate to="/dashboard" replace />;
  //   }
  //   // Cho phép vào các trang khác (bao gồm /kyc/verified và các domain khác)
  //   return children;
  // }

  // // Logic cho các trạng thái KYC: NotKyc, UnderReview, Rejected
  // // Kiểm tra xem user có đang ở đúng trang KYC theo kycStatus không

  // // Nếu user đang ở đúng trang KYC yêu cầu
  // if (location.pathname === currentRequiredUrl) {
  //   // User đang ở đúng trang, cho phép vào
  //   return children;
  // }

  // // Nếu user đang ở trang KYC khác (không phải trang yêu cầu)
  // // Ví dụ: kycStatus = UnderReview nhưng đang ở /kyc/submit
  // // => Redirect ngay lập tức (không cần check isInitialMount vì đã check trong useEffect)
  // if (location.pathname.startsWith('/kyc') && location.pathname !== currentRequiredUrl) {
  //   // Block và reload lại trang đúng theo kycStatus
  //   window.location.href = currentRequiredUrl;
  //   return null;
  // }

  // // Nếu user đang ở trang không phải KYC và kycStatus yêu cầu một trang KYC cụ thể
  // // Redirect ngay lập tức
  // if (!location.pathname.startsWith('/kyc') && currentRequiredUrl) {
  //   // Reload lại trang đúng theo kycStatus
  //   window.location.href = currentRequiredUrl;
  //   return null;
  // }

  return children;
}
